window.__CA_THEME_MODULE_FACTORIES__ = window.__CA_THEME_MODULE_FACTORIES__ || [];
window.__CA_THEME_MODULE_FACTORIES__.push(function() {
  "use strict";
  if (theme.Collection) return;
  theme.Collection = (function() {
    function FeaturedCollection(container) {
      this.container = container;
      this.colorSwatchHovering();
    }
    FeaturedCollection.prototype = {
      colorSwatchHovering: function() {
        var colorImages = this.container.querySelectorAll(".grid-product__color-image");
        if (!colorImages.length) return;
        this.container.querySelectorAll(".color-swatch--with-image").forEach(function(swatch) {
          swatch.addEventListener("mouseenter", function() {
            var el = this.container.querySelector(".grid-product__color-image--" + swatch.dataset.variantId);
            if (!el) return;
            el.style.backgroundImage = "url(" + swatch.dataset.variantImage + ")";
            el.classList.add("is-active");
          }.bind(this));
          swatch.addEventListener("mouseleave", function() {
            var el = this.container.querySelector(".grid-product__color-image--" + swatch.dataset.variantId);
            if (el) el.classList.remove("is-active");
          }.bind(this));
        }.bind(this));
      }
    };
    return FeaturedCollection;
  })();
});
